/**
 * 导航栏组件
 */
import { i18n } from '../core/I18n.js';

export class Navigation {
  constructor(options = {}) {
    this.showLangSwitcher = options.showLangSwitcher !== false;
    this.showBackButton = options.showBackButton || false;
    this.onBack = options.onBack || (() => {});
    this.element = this.render();
  }
  
  render() {
    const nav = document.createElement('nav');
    nav.className = 'navbar';
    
    const content = document.createElement('div');
    content.className = 'navbar-content';
    
    // 品牌/返回区域
    const brand = document.createElement('div');
    brand.className = 'navbar-brand';
    
    if (this.showBackButton) {
      const backBtn = document.createElement('button');
      backBtn.className = 'btn-back';
      backBtn.innerHTML = '←';
      backBtn.addEventListener('click', () => this.onBack());
      brand.appendChild(backBtn);
    } else {
      const icon = document.createElement('span');
      icon.className = 'navbar-brand-icon';
      icon.textContent = '🎮';
      brand.appendChild(icon);
    }
    
    const title = document.createElement('span');
    title.textContent = i18n.t('app.name');
    brand.appendChild(title);
    
    content.appendChild(brand);
    
    // 控制区域
    if (this.showLangSwitcher) {
      const langSwitcher = this.createLangSwitcher();
      content.appendChild(langSwitcher);
    }
    
    nav.appendChild(content);
    return nav;
  }
  
  createLangSwitcher() {
    const container = document.createElement('div');
    container.className = 'lang-switcher';
    
    const languages = [
      { code: 'zh', label: '中文' },
      { code: 'en', label: 'EN' }
    ];
    
    const currentLang = i18n.getLanguage();
    
    languages.forEach(lang => {
      const btn = document.createElement('button');
      btn.className = `lang-btn ${lang.code === currentLang ? 'active' : ''}`;
      btn.textContent = lang.label;
      btn.addEventListener('click', () => {
        i18n.setLanguage(lang.code);
        window.location.reload();
      });
      container.appendChild(btn);
    });
    
    return container;
  }
  
  mount(parent) {
    parent.insertBefore(this.element, parent.firstChild);
  }
}
